import React, { FunctionComponent } from 'react'
import { Grid, Text, Button, Heading, useIsTheme, Theme } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../utils/responsive'
import styles from './style.module.css'
import { useAppRouter } from '../../state'
import { Route } from '../../config/router'
import { useTranslation } from '../../utils/convergence'
import { Trans, TransMaskedText } from '..'
import { ResendInstructions } from './ResendInstructions'

interface Props {
  email?: string
  isMobileLogin: boolean
  clickHandler: () => void
}

export const EmailSent: FunctionComponent<Props> = ({ email, isMobileLogin, clickHandler }) => {
  const isCashTheme = useIsTheme(Theme.Cash)
  const { t } = useTranslation()
  const { buttonSize, headingSize } = useCheckoutSizes()
  const router = useAppRouter()
  const backHandler = (): void => {
    router.push(Route.ENTER_PASSWORD)
  }
  const textColor = isCashTheme ? 'Subtle' : undefined

  return (
    <>
      <Heading size={headingSize}>{t('passwordResetRequired:checkEmail')}</Heading>
      <div className={styles.mt4}></div>
      <Grid>
        <Text color={textColor}>
          {isMobileLogin && t('passwordResetRequired:sentBodyForPhoneLogin')}
          {!isMobileLogin && (
            <span data-testid='email-sent-email-login-div'>
              <Trans
                i18nKey={'passwordResetRequired:sentBody'}
                values={{ email }}
                components={{
                  email: (
                    <strong>
                      <TransMaskedText
                        actionName='Password reset required, email sent'
                        text={email ?? ''}
                        testNameSpace='password-reset-required-email-sent-email'
                      />
                    </strong>
                  ),
                }}
              />
            </span>
          )}
        </Text>
      </Grid>
      <ResendInstructions clickHandler={clickHandler} />
      <Grid.Item>
        <Button.Secondary onClick={backHandler} size={buttonSize} testNameSpace='back' padding='Fluid'>
          {t('passwordResetRequired:back')}
        </Button.Secondary>
      </Grid.Item>
    </>
  )
}
